(function () {
  'use strict';

  var root = document.querySelector('[data-pf-track-order]');

  if (!root) {
    return;
  }

  var form = root.querySelector('[data-pf-track-form]');
  var orderInput = root.querySelector('#PfTrackOrderNumber');
  var emailInput = root.querySelector('#PfTrackEmail');
  var submitButton = root.querySelector('[data-pf-track-submit]');
  var submitText = root.querySelector('[data-pf-track-submit-text]');
  var spinner = root.querySelector('[data-pf-track-spinner]');
  var message = root.querySelector('[data-pf-track-message]');
  var result = root.querySelector('[data-pf-track-result]');
  var resultNumber = root.querySelector('[data-pf-track-result-number]');
  var resultDate = root.querySelector('[data-pf-track-result-date]');
  var resultStatus = root.querySelector('[data-pf-track-result-status]');
  var resultCloseButtons = root.querySelectorAll('[data-pf-track-result-close]');
  var lifecycle = root.querySelector('[data-pf-track-lifecycle]');
  var itemsWrap = root.querySelector('[data-pf-track-items-wrap]');
  var itemsContainer = root.querySelector('[data-pf-track-items]');
  var rentalDetailsWrap = root.querySelector('[data-pf-track-rental-details]');
  var rentalStart = root.querySelector('[data-pf-track-rental-start]');
  var rentalEnd = root.querySelector('[data-pf-track-rental-end]');
  var deliveryTiming = root.querySelector('[data-pf-track-delivery-timing]');
  var returnTiming = root.querySelector('[data-pf-track-return-timing]');
  var detailStart = root.querySelector('[data-pf-track-detail-start]');
  var detailEnd = root.querySelector('[data-pf-track-detail-end]');
  var detailDelivery = root.querySelector('[data-pf-track-detail-delivery]');
  var detailReturn = root.querySelector('[data-pf-track-detail-return]');
  var summary = root.querySelector('[data-pf-track-summary]');
  var orderTotal = root.querySelector('[data-pf-track-order-total]');
  var depositRow = root.querySelector('[data-pf-track-deposit-row]');
  var depositStatus = root.querySelector('[data-pf-track-deposit-status]');
  var helpModal = root.querySelector('[data-pf-track-help-modal]');
  var helpOpenButton = root.querySelector('[data-pf-track-help-open]');
  var helpSendButton = root.querySelector('[data-pf-track-help-send]');
  var enquiryType = root.querySelector('[data-pf-track-enquiry-type]');
  var enquiryMessage = root.querySelector('[data-pf-track-enquiry-message]');
  var helpError = root.querySelector('[data-pf-track-help-error]');
  var helpCloseButtons = root.querySelectorAll('[data-pf-track-help-close]');
  var endpoint = root.getAttribute('data-endpoint') || '/apps/playforce-order-tracker/lookup';

  if (!form || !orderInput || !emailInput || !submitButton || !message || !result) {
    return;
  }

  var activeController = null;
  var currentOrderData = null;
  var lastFocusedElement = null;

  function normaliseOrderNumber(value) {
    return String(value || '')
      .trim()
      .replace(/^#+/, '')
      .replace(/\s+/g, '');
  }

  function isValidOrderNumber(value) {
    return /^[A-Za-z0-9-]{1,40}$/.test(value);
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function setFieldValidity(input, isValid) {
    input.setAttribute('aria-invalid', isValid ? 'false' : 'true');
  }

  function clearMessage() {
    message.hidden = true;
    message.classList.remove('is-info');
    message.textContent = '';
  }

  function showMessage(text, type) {
    message.textContent = text;
    message.classList.toggle('is-info', type === 'info');
    message.hidden = false;
  }

  function setLoading(isLoading) {
    submitButton.disabled = isLoading;
    spinner.hidden = !isLoading;
    submitText.textContent = isLoading ? 'Checking Order…' : 'View Order Status';
  }

  function clearNode(node) {
    while (node.firstChild) {
      node.removeChild(node.firstChild);
    }
  }

  function createTextElement(tagName, className, text) {
    var element = document.createElement(tagName);
    element.className = className;
    element.textContent = text || '';
    return element;
  }

  function renderLifecycle(data) {
    var steps = Array.isArray(data.steps) ? data.steps : [];
    var currentIndex = Number(data.currentIndex);

    clearNode(lifecycle);

    if (!steps.length) {
      return;
    }

    lifecycle.style.setProperty('--pf-track-step-count', String(steps.length));

    steps.forEach(function (label, index) {
      var step = document.createElement('div');
      var className = 'pf-track-step';

      if (index < currentIndex) {
        className += ' is-complete';
      }

      if (index === currentIndex) {
        className += ' is-current';
      }

      step.className = className;

      var dot = document.createElement('span');
      dot.className = 'pf-track-step-dot';
      dot.setAttribute('aria-hidden', 'true');

      var labelElement = createTextElement('span', 'pf-track-step-label', label);

      step.appendChild(dot);
      step.appendChild(labelElement);
      lifecycle.appendChild(step);
    });
  }

  function renderItems(items) {
    clearNode(itemsContainer);

    if (!Array.isArray(items) || !items.length) {
      itemsWrap.hidden = true;
      return;
    }

    items.forEach(function (item) {
      var row = document.createElement('div');
      row.className = 'pf-track-item';

      var copy = document.createElement('div');
      copy.appendChild(
        createTextElement('p', 'pf-track-item-title', item.title || 'Item')
      );

      if (item.variant) {
        copy.appendChild(
          createTextElement('p', 'pf-track-item-variant', item.variant)
        );
      }

      var qty = createTextElement(
        'div',
        'pf-track-item-qty',
        'Qty ' + String(item.quantity || 1)
      );

      row.appendChild(copy);
      row.appendChild(qty);
      itemsContainer.appendChild(row);
    });

    itemsWrap.hidden = false;
  }

  function setDetail(row, valueNode, value) {
    if (!row || !valueNode) {
      return false;
    }

    var cleanValue = String(value || '').trim();
    row.hidden = !cleanValue;
    valueNode.textContent = cleanValue;

    return Boolean(cleanValue);
  }

  function renderRentalDetails(details, lifecycleType) {
    if (!rentalDetailsWrap) {
      return;
    }

    details = details || {};

    var hasStart = setDetail(detailStart, rentalStart, details.startDate);
    var hasEnd = setDetail(detailEnd, rentalEnd, details.endDate);
    var hasDelivery = setDetail(detailDelivery, deliveryTiming, details.deliveryTiming);
    var hasReturn = setDetail(detailReturn, returnTiming, details.returnTiming);

    rentalDetailsWrap.hidden =
      lifecycleType !== 'rental' ||
      !(hasStart || hasEnd || hasDelivery || hasReturn);
  }

  function formatMoney(total) {
    if (!total || total.amount === undefined || total.amount === null) {
      return '';
    }

    var amount = Number(total.amount);
    var currency = String(total.currencyCode || 'SGD').toUpperCase();

    if (!Number.isFinite(amount)) {
      return '';
    }

    try {
      return new Intl.NumberFormat('en-SG', {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'symbol'
      }).format(amount);
    } catch (error) {
      return currency + ' ' + amount.toFixed(2);
    }
  }

  function renderSummary(order) {
    if (!summary || !orderTotal || !depositRow || !depositStatus) {
      return;
    }

    var totalText = formatMoney(order.total);
    var depositText = String(order.depositStatus || '').trim();

    orderTotal.textContent = totalText;
    depositStatus.textContent = depositText;
    depositRow.hidden = !depositText;
    summary.hidden = !totalText && !depositText;
  }

  function formatOrderDate(value) {
    if (!value) {
      return '';
    }

    var date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return String(value);
    }

    try {
      return new Intl.DateTimeFormat('en-SG', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      }).format(date);
    } catch (error) {
      return String(value);
    }
  }

  function renderResult(order) {
    resultNumber.textContent = 'Order ID: ' + String(order.number || '').replace(/^#/, '');
    resultDate.textContent = formatOrderDate(order.createdAt);
    resultStatus.textContent = order.currentStatus || 'Order Received';

    renderLifecycle(order.lifecycle || {});
    renderRentalDetails(
      order.rentalDetails || {},
      order.lifecycle && order.lifecycle.type
    );
    renderItems(order.items || []);
    renderSummary(order);
    currentOrderData = order;

    result.hidden = false;

    if (window.matchMedia('(min-width: 750px)').matches) {
      document.body.classList.add('pf-track-result-open');
    } else {
      window.requestAnimationFrame(function () {
        result.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    }
  }

  function hideResult() {
    result.hidden = true;
    currentOrderData = null;
    document.body.classList.remove('pf-track-result-open');
  }

  Array.prototype.forEach.call(resultCloseButtons, function (button) {
    button.addEventListener('click', hideResult);
  });

  function openHelpModal() {
    if (!helpModal || !enquiryType || !currentOrderData) {
      return;
    }

    lastFocusedElement = document.activeElement;
    helpModal.hidden = false;
    helpModal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pf-track-modal-open');

    window.setTimeout(function () {
      enquiryType.focus();
    }, 0);
  }

  function closeHelpModal() {
    if (!helpModal) {
      return;
    }

    helpModal.hidden = true;
    helpModal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('pf-track-modal-open');

    if (helpError) {
      helpError.classList.remove('is-visible');
    }

    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus();
    }
  }

  function normaliseVariant(variant) {
    if (!variant || variant === 'Default Title') {
      return '';
    }

    return variant;
  }

  function formatHelpOrderDate(value) {
    if (!value) {
      return '';
    }

    var date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return String(value);
    }

    var months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sept',
      'Oct',
      'Nov',
      'Dec'
    ];

    return (
      date.getDate() +
      ' ' +
      months[date.getMonth()] +
      ' ' +
      date.getFullYear()
    );
  }

  function buildHelpMessage(orderData, selectedEnquiry, note) {
    var lines = [];
    var cleanOrderId = String(orderData.number || '').replace(/^#/, '');

    lines.push('Hi Playforce, I need help with my order.');
    lines.push('');
    lines.push('Order ID: ' + cleanOrderId);

    if (orderData.createdAt) {
      lines.push('Order Date: ' + formatHelpOrderDate(orderData.createdAt));
    }

    if (
      orderData.lifecycle &&
      orderData.lifecycle.type === 'rental' &&
      orderData.rentalDetails
    ) {
      var rentalDetails = orderData.rentalDetails;

      lines.push('');
      lines.push('Rental Date:');

      if (rentalDetails.startDate) {
        lines.push('Start date: ' + rentalDetails.startDate);
      }

      if (rentalDetails.endDate) {
        lines.push('End date: ' + rentalDetails.endDate);
      }

      if (rentalDetails.deliveryTiming) {
        lines.push('Delivery timing: ' + rentalDetails.deliveryTiming);
      }

      if (rentalDetails.returnTiming) {
        lines.push('Return timing: ' + rentalDetails.returnTiming);
      }
    }

    lines.push('');
    lines.push('Items Ordered:');

    (orderData.items || []).forEach(function (item) {
      var itemLine = '• ' + (item.title || 'Item');
      var variant = normaliseVariant(item.variant);

      if (variant) {
        itemLine += ' — ' + variant;
      }

      itemLine += ' × ' + String(item.quantity || 1);
      lines.push(itemLine);
    });

    lines.push('');
    lines.push('Enquiry: ' + selectedEnquiry);
    lines.push('Details: ' + note);

    return lines.join('\n');
  }

  if (helpOpenButton) {
    helpOpenButton.addEventListener('click', openHelpModal);
  }

  Array.prototype.forEach.call(helpCloseButtons, function (button) {
    button.addEventListener('click', closeHelpModal);
  });

  if (enquiryType) {
    enquiryType.addEventListener('change', function () {
      if (enquiryType.value && helpError) {
        helpError.classList.remove('is-visible');
      }
    });
  }

  if (helpSendButton) {
    helpSendButton.addEventListener('click', function () {
      var selectedEnquiry = enquiryType ? enquiryType.value : '';
      var note = enquiryMessage ? enquiryMessage.value.trim() : '';

      if (!selectedEnquiry) {
        if (helpError) {
          helpError.classList.add('is-visible');
        }

        if (enquiryType) {
          enquiryType.focus();
        }

        return;
      }

      if (!currentOrderData) {
        return;
      }

      var message = buildHelpMessage(
        currentOrderData,
        selectedEnquiry,
        note
      );

      var whatsappUrl =
        'https://wa.me/6591151460?text=' + encodeURIComponent(message);

      window.open(whatsappUrl, '_blank', 'noopener');
      closeHelpModal();
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') {
      return;
    }

    if (
      helpModal &&
      !helpModal.hidden
    ) {
      closeHelpModal();
      return;
    }

    if (
      result &&
      !result.hidden &&
      window.matchMedia('(min-width: 750px)').matches
    ) {
      hideResult();
    }
  });

  function genericNotFoundMessage() {
    return 'We couldn’t find a matching order. Check your order number and email, or create a Playforce account using the same email used for your order to view all previous orders.';
  }

  function handleApiError(payload, status) {
    var code = payload && payload.code ? payload.code : '';

    if (status === 429 || code === 'RATE_LIMITED') {
      return 'Too many attempts. Please wait a few minutes before trying again.';
    }

    if (code === 'ORDER_TOO_OLD' || code === 'ORDER_NOT_AVAILABLE') {
      return genericNotFoundMessage();
    }

    if (status === 503 || code === 'TRACKER_NOT_CONFIGURED') {
      return 'Order tracking is temporarily unavailable. Please try again later.';
    }

    return genericNotFoundMessage();
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();

    clearMessage();
    hideResult();

    var orderNumber = normaliseOrderNumber(orderInput.value);
    var email = String(emailInput.value || '').trim().toLowerCase();

    var orderValid = isValidOrderNumber(orderNumber);
    var emailValid = isValidEmail(email);

    setFieldValidity(orderInput, orderValid);
    setFieldValidity(emailInput, emailValid);

    if (!orderValid || !emailValid) {
      showMessage('Enter a valid order number and the email address used for that order.');
      (!orderValid ? orderInput : emailInput).focus();
      return;
    }

    orderInput.value = orderNumber;

    if (activeController) {
      activeController.abort();
    }

    activeController = new AbortController();

    var timeoutId = window.setTimeout(function () {
      activeController.abort();
    }, 12000);

    setLoading(true);

    fetch(endpoint, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        orderNumber: orderNumber,
        email: email
      }),
      signal: activeController.signal
    })
      .then(function (response) {
        return response
          .json()
          .catch(function () {
            return {};
          })
          .then(function (payload) {
            return {
              ok: response.ok,
              status: response.status,
              payload: payload
            };
          });
      })
      .then(function (response) {
        if (!response.ok || !response.payload || response.payload.ok !== true) {
          showMessage(handleApiError(response.payload, response.status));
          return;
        }

        if (!response.payload.order) {
          showMessage(genericNotFoundMessage());
          return;
        }

        renderResult(response.payload.order);
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') {
          showMessage('The request took too long. Please try again.');
          return;
        }

        showMessage('Order tracking is temporarily unavailable. Please try again later.');
      })
      .finally(function () {
        window.clearTimeout(timeoutId);
        activeController = null;
        setLoading(false);
      });
  });

  orderInput.addEventListener('input', function () {
    setFieldValidity(orderInput, true);
    clearMessage();
  });

  emailInput.addEventListener('input', function () {
    setFieldValidity(emailInput, true);
    clearMessage();
  });
})();
